import React from 'react';
import { Toaster } from 'react-hot-toast';
import {
  Button,
  Dialog,
  DialogBody,
  DialogHeader,
  Input,
  Slider,
  Spinner,
} from '@material-tailwind/react';

import FeeRateCard from './FeeRateCard';
import mintImg from '../assets/imgs/mintimg.png';

/**
 * The mint form and the inscribing progress dialog, shared by the /mint page
 * and the landing page. All state comes from useMintFlow() so both callers
 * drive the same flow; this component only renders it.
 */
export default function MintDialogs({ flow }) {
  const {
    feeRateTabs,
    feeRateMode,
    setFeeRateMode,
    feeRates,
    customFee,
    handleCustomFee,
    sliderValue,
    setSliderValue,
    amount,
    setAmount,
    addAmount,
    deductAmount,
    address,
    setAddress,
    deployCount,
    deployLimit,
    show,
    setShow,
    inscriptionStatus,
    setInscriptionStatus,
    showMintForm,
    setShowMintForm,
    handleMint,
  } = flow;

  return (
    <>
      <Dialog open={showMintForm} size={'xs'}>
        <DialogHeader>
          <div className='flex flex-row justify-center items-center w-full'>
            <img src={mintImg} className='w-[48px] h-[48px]' />
          </div>
        </DialogHeader>
        <DialogBody>
          <div className='flex flex-col gap-3 w-full min-h-[160px]'>
            <div>
              <Input
                type='text'
                color='black'
                label='Inscription Receiver Address'
                className='w-full min-w-[200px]'
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
              />
            </div>
            <div className='text-black'>How many Eyes do you want to mint?</div>
            <div className='flex flex-row items-center justify-between gap-3'>
              <div className='flex flex-row gap-2 items-center border-red-900 border-solid border-[2px] py-2 px-4 rounded-md text-black'>
                <div
                  className='font-bold cursor-pointer select-none'
                  onClick={() => {
                    deductAmount();
                  }}
                >
                  -
                </div>
                <div className='w-[50px]'>
                  <input
                    type='number'
                    className='w-full bg-transparent text-center'
                    value={amount}
                    onChange={(e) => {
                      setAmount(e.target.value);
                    }}
                  />
                </div>
                <div
                  className='font-bold cursor-pointer select-none'
                  onClick={() => {
                    addAmount();
                  }}
                >
                  +
                </div>
              </div>
              <div className='text-[12px] font-bold text-black'>
                {deployCount}/{deployLimit} MINTED
              </div>
            </div>
            <div className='text-black'>
              Select the network fee you want to pay:
            </div>
            <div className='grid grid-cols-3 gap-3'>
              <FeeRateCard
                header={feeRateTabs[1]}
                rate={feeRates[feeRateTabs[1]]}
                active={feeRateMode}
                onClick={() => {
                  setFeeRateMode(feeRateTabs[1]);
                }}
              />
              <FeeRateCard
                header={feeRateTabs[2]}
                rate={feeRates[feeRateTabs[2]]}
                active={feeRateMode}
                onClick={() => {
                  setFeeRateMode(feeRateTabs[2]);
                }}
              />
              <FeeRateCard
                header={feeRateTabs[3]}
                rate={customFee}
                active={feeRateMode}
                onClick={() => {
                  setFeeRateMode(feeRateTabs[3]);
                }}
              />
            </div>
            {feeRateMode == 'Custom' ? (
              <div className='flex flex-row gap-3 items-center'>
                <Slider
                  className='sm:flex hidden'
                  color='blue'
                  value={sliderValue}
                  onChange={(e) => setSliderValue(e.target.value)}
                />
                <div className='sm:max-w-[200px] w-full'>
                  <Input
                    type='number'
                    color='black'
                    label='Custom Fee'
                    className='sm:max-w-[200px] w-full'
                    value={customFee}
                    onChange={(e) => {
                      handleCustomFee(e.target.value);
                    }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className='flex flex-row w-full justify-center gap-4'>
              <button
                className='border-[2px] text-black font-bold border-solid border-red-900 rounded-md py-2 min-w-[140px]'
                onClick={handleMint}
              >
                Mint
              </button>
              <button
                className='border-[2px] text-black font-bold border-solid border-red-900 rounded-md py-2 min-w-[140px]'
                onClick={() => {
                  setShowMintForm(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </DialogBody>
      </Dialog>
      <Dialog open={show} size={'xs'}>
        <DialogHeader>
          {inscriptionStatus ? (
            <div className='flex flex-row w-full justify-center mt-6 text-[32px] font-bold text-green-600'>
              Inscription Success
            </div>
          ) : (
            <div className='flex flex-row w-full justify-center mt-6 text-[32px] font-bold text-primary'>
              Inscribing Now
            </div>
          )}
        </DialogHeader>
        <DialogBody>
          <div className='flex flex-col gap-3 w-full min-h-[160px]'>
            {inscriptionStatus ? (
              <div className='flex flex-col items-center gap-8'>
                <div className='flex flex-row justify-center w-full text-[20px] px-6 font-semibold text-[#616161] text-center'>
                  Thank you for participating. Together we are changing the
                  digital landscape.
                </div>
                <div className='w-[160px]'>
                  <Button
                    onClick={() => {
                      setShow(false);
                      setInscriptionStatus(false);
                    }}
                    fullWidth
                  >
                    Close
                  </Button>
                </div>
              </div>
            ) : (
              <div className='flex flex-col items-center gap-5'>
                <div className='flex flex-row justify-center w-full font-semibold text-[#616161] text-[20px] px-6 text-center'>
                  Don´t close this window before the transaction is complete.
                </div>
                <Spinner className='h-12 w-12' />
              </div>
            )}
          </div>
        </DialogBody>
      </Dialog>
      <Toaster position='top-right' />
    </>
  );
}
